import { render, staticRenderFns } from "./AccountRecovery.vue?vue&type=template&id=d32c1d48&"
import script from "./AccountRecovery.vue?vue&type=script&lang=js&"
export * from "./AccountRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports